// @file Helper methods to scroll to post
// TODO: Create and use non-jquery version in bits/dom_helpers instead.
import { $ } from 'bits/jquery'

export const scrollNewPostIntoView = el => {
  const element = el ? $(el) : document.getElementById('wish-new')
  element.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'nearest' })
}
export const scrollToPost = (containerElement, postAttributes) => {
  const wallContainerWidth = containerElement.offsetWidth
  // const wallContainerHeight = containerElement.offsetHeight
  const scrollLeft = Math.max(postAttributes.left - (wallContainerWidth - postAttributes.width) / 2, 0)
  const scrollTop = Math.max(postAttributes.top - 200, 0)
  $(containerElement).animate({ scrollLeft: scrollLeft, scrollTop: scrollTop })
}
